import React from 'react'
import Dashboard from '../Components/Dashboard/Dashboard'
import Sidebar from '../Components/Sidebar/Sidebar'

const Main = () => {
  return (
    <>
    <Sidebar />
    <Dashboard />
    </>
  )
}

export default Main